// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__dTK5R","fadeIn":"styles_fadeIn__lNi42","contentContainer":"styles_contentContainer__IC5dw","heading":"styles_heading__RNiHO"};